module.exports = __webpack_public_path__ + "static/img/gouliTec.2d1ff51.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/bottomNav/gouliTec.png
// module id = QScG
// module chunks = 1